const config = {
    // BASE_URL: '/',
    BASE_URL: '/svhs/',
};

export default config;